/**
 * backend-api
 * LoopBack Application
 *
 * OpenAPI spec version: 5.18.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ObjectID from './ObjectID';

/**
* The CategoryDealer model module.
* @module model/CategoryDealer
* @version 5.18.0
*/
export default class CategoryDealer {
    /**
    * Constructs a new <code>CategoryDealer</code>.
    * @alias module:model/CategoryDealer
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>CategoryDealer</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CategoryDealer} obj Optional instance to populate.
    * @return {module:model/CategoryDealer} The populated <code>CategoryDealer</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryDealer();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ObjectID.constructFromObject(data['id']);
            }
            if (data.hasOwnProperty('categoryId')) {
                obj['categoryId'] = ObjectID.constructFromObject(data['categoryId']);
            }
            if (data.hasOwnProperty('dealerId')) {
                obj['dealerId'] = ObjectID.constructFromObject(data['dealerId']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/ObjectID} id
    */
    id = undefined;
    /**
    * @member {module:model/ObjectID} categoryId
    */
    categoryId = undefined;
    /**
    * @member {module:model/ObjectID} dealerId
    */
    dealerId = undefined;




}
